import React, { useEffect } from "react";
import styles from "./UnAssignConfirmation.module.css";
import ModalView from "@modals/modalview/ModalView";
import confirmationIcon from "@assets/icons/unassign-icon.svg";
import closeIcon from "@assets/icons/close-icon.svg";

interface UnAssignConfirmationProps {
  isOpen: boolean;
  onUnAssign: () => void;
  onClose: () => void;
}

function UnAssignConfirmation({
  isOpen,
  onUnAssign,
  onClose,
}: UnAssignConfirmationProps) {
  useEffect(() => {
    if (!isOpen) return;
  }, [isOpen]);
  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.closeHeader}>
          <button className={styles.closeBtn} onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
        <img src={confirmationIcon} className={styles.confirmationIcon} />
        <div className={styles.headingtext}>"Unassign" task?</div>
        <p>
          This will unassign you from the current evaluation task. Your progress will not be saved.
        </p>
        <div className={styles.btnContainer}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.unassignBtn} onClick={onUnAssign}>
            Unassign
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default UnAssignConfirmation;
